import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { Link } from "react-router-dom";
import { useTheme } from "../../Theme";

export default function Footer() {
  const { darkMode, toggleModes } = useTheme();

  const footerClasses = darkMode
    ? "bg-slate-800 text-gray-200 "
    : "bg-white-800 text-gray-400 ";

  const headingClasses = darkMode
    ? "text-white"
    : "text-gray-600";



  return (
    <footer className={`footer-section-wrapper  print:hidden  ${footerClasses} `}>
      <div className={`container-x block mx-auto pt-[56px] ${footerClasses}`}>
        <div className={`lg:flex border-t border-qgray-border pt-8 justify-between mb-[50px] ${footerClasses}`}>
          <div className={`lg:w-[424px]  ml-0 w-full mb-10 lg:mb-0 ${footerClasses} `}>
            <Link to="/about">
              <h1 className={`text-[18] font-500  mb-5 ${headingClasses}`}>
                About Us
              </h1>
            </Link>
            <p className=" text-[15px] w-[247px] leading-[28px]">
              MarketFusion is an{" "}
              <Link to="http://www.ipserlab.com">
                <span className=" text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
                  IpserLab, LLC
                </span>
              </Link>{" "}
              startup company devoted to providing a contract manufacturing marketplace.
            </p>
          </div>
          <div className="flex-1 lg:flex">
            <div className="lg:w-1/2 lg:flex lg:flex-col items-center w-full mb-10 lg:mb-0">
              <div>
                <div className="mb-5">
                  <h6 className={`text-[18] font-500 ${headingClasses} `}>Join</h6>
                </div>
                <div>
                  <ul className="flex flex-col space-y-4 ">
                    <li>
                      <Link to="/event">
                        <span className=" text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
                          Start an Event
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/conversation">
                        <span className=" text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
                          Start a Conversation
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/about">
                        <span className=" text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
                          Join a Conversation
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="lg:w-1/2 w-full mb-10 lg:mb-0">
              <div className="mb-5">
                <h6 className={`text-[18] font-500 ${headingClasses} `}>
                  Information
                </h6>
              </div>
              <div>
                <ul className="flex flex-col space-y-4 ">
                  <li>
                    <Link to="/faq">
                      <span className=" text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
                        FAQ
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/terms">
                      <span className="text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
                        Terms and Conditions
                      </span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacy">
                      <span className="text-[15px] hover:text-blue-400 border-b border-transparent  cursor-pointer capitalize">
                        Privacy Policy
                      </span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom-bar border-t border-qgray-border lg:h-[82px] lg:flex justify-between items-center">
          <div className="flex lg:space-x-5 justify-between items-center mb-3">
            <div className="flex space-x-5 items-center">
              <a href="http://www.facebook.com" target="new">
                {/* <FacebookIcon sx={{ color: "#797979" }} /> */}
                <FacebookIcon className={`${headingClasses}`} />
              </a>
              <a href="http://www.youtube.com" target="new">
                <YouTubeIcon className={`${headingClasses}`} />
              </a>
            </div>
            <span className={`sm:text-base text-[10px] ${headingClasses} font-300`}>
              &copy; 2024 IpserLab LLC. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
